<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    fill="none"
    viewBox="0 0 21 23"
  >
    <path
      :fill="fill"
      :stroke="fill"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3.2"
      d="m2.523 1.9 16 9.6-16 9.6V1.9Z"
    />
  </svg>
</template>

<script>
import { iconPropsFunc } from "./mixins/icons";

export default {
  name: "IconPlay",
  mixins: [iconPropsFunc()],
};
</script>

<style lang="scss" scoped></style>
